import format from '../Strings/format';
import Exception from './Exception';
import SR from '../i18n/en/exceptions.strings.json';
export default class IndexOutOfRangeException extends Exception {
    constructor(variableName, index, minBound, maxBound, innerException) {
        const _message = format(SR.IndexOutOfRangeException_message, index, variableName, minBound, maxBound);
        if (innerException) {
            super(_message, innerException);
        }
        else {
            super(_message);
        }
        this.name = 'OutOfBoundsException';
    }
}
